<template>
  <div>
    <v-card id="card" class="card-text rounded-0" color="" style="">
      <div :class="[getItemBackColor(item),'px-1']">
        <v-row>
          <v-col class="my-auto py-0" @click="clickItem">
            <v-row>
              <v-col cols="">
                <v-row>
                  <v-col cols="6" class="">
                    <div class="d-flex flex-column">
                      <span>{{ item.personName }}</span>
                      <span class="text-muted"
                        >{{ $t("card-no") }}:
                        <span class="text-value">{{ item.PERNO }}</span></span
                      >
                    </div>
                  </v-col>
                  <v-col cols="6" class="">
                    <span class="">{{ getAbsentType(item.AbsentType) }}</span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="d-flex my-auto py-0" cols="auto">
            <v-btn icon @click="show = !show" class="card-text">
              <v-icon>{{
                show ? "mdi-chevron-up" : "mdi-chevron-down"
              }}</v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <v-expand-transition class="">
          <div v-show="show" class="mt-1">
            <v-row @click="clickItem">
              <v-col>
                <v-row>
                  <v-col cols="6" class="my-auto"
                    >{{ $t("SectionName") }} :
                    <span class="text-value">{{ item.sectionName }}</span>
                  </v-col>
                  <v-col cols="6" class="my-auto"
                    >{{ $t("WorkGroup") }} :
                    <span class="text-value">{{ item.workGroupName }}</span>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="auto py-0">
                <div style="width: 36px; height: 36px"></div>
              </v-col>
            </v-row>
          </div>
        </v-expand-transition>
      </div>
      <v-divider class="bg-white pa-0 ma-0"></v-divider>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    item: Object,
  },
  computed: {},
  data() {
    return {
      show: false,
    };
  },
  methods: {
    getAbsentType(AbsentType) {
      switch (AbsentType.toString()) {
        case "0":
          return "غیبت";
        case "1":
          return "مرخصی روزانه";
        case "2":
          return "ماموریت روزانه";
        case "3":
          return "مرخصی ساعتی";
        case "4":
          return "ماموریت ساعتی";
        case "5":
          return "تاخیر سرویس";
        default:
          return "غیبت";
      }
    },
    clickItem() {
      this.$emit("onClickItem", this.item);
    },
    getItemBackColor(item) {
      if (this.getAbsentType(item.AbsentType) == "غیبت") {
        return "bg-red";
      }
      return "";
    },
  },
};
</script>

<style scoped>
* {
  padding: 0px;
  margin: 0px;
}

.card-text {
  font-size: 0.875rem !important;
  color: var(--black) !important;
}

.text-caption-color {
  color: #8b8b8b;
}

.state .v-icon {
  font-size: 1rem;
}
</style>